import React from 'react';

import { useJobProspectsState, useJobProspectsActions } from './JobProspectsContext';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const PaymentMethodRequiredModal = () => {
  const state = useJobProspectsState();
  const { closePaymentMethodModal } = useJobProspectsActions();

  const isOpen = state?.paymentMethodModalIsOpen;

  const handleGoToAccount = () => {
    window.location.href = '/your_account';
  };

  return (
    <StandardModal
      isOpen={isOpen}
      contentLabel="Payment Method Required"
      onRequestClose={closePaymentMethodModal}
    >
      <Form>
        <FormInstruction>
          <strong>Payment method required</strong>
          <br />
          <br />
          To subscribe to Premium Job Recommendations, you need a payment method on file.
          <br />
          <br />
          Visit your Account page to add a payment method, then come back here to subscribe.
        </FormInstruction>

        <ResponsiveContainer name="form-actions">
          <FormActions>
            <Button
              variant="secondary"
              onClick={closePaymentMethodModal}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleGoToAccount}
            >
              Go to Account
            </Button>
          </FormActions>
        </ResponsiveContainer>
      </Form>
    </StandardModal>
  );
};

export default PaymentMethodRequiredModal;
